import { useRouter } from '@router'
import { Toggle } from '@components/Toggle.tsx'

// Explore/Map view switch in the header. Selection is derived from the route
// rather than context, so each option is a router <Link>.
export const ActivityViewToggle = () => {
	const { path } = useRouter()
	const isMap = path === '/activities/map'

	return (
		<Toggle
			ariaLabel="Explore or map view"
			options={[
				{
					key: 'explore',
					label: 'Explore',
					href: '/activities',
					active: !isMap,
				},
				{
					key: 'map',
					label: 'Map',
					href: '/activities/map',
					active: isMap,
				},
			]}
		/>
	)
}
